import { useAlgoliaLocale } from "@components/search/hooks/useAlgoliaLocale";

export const useAlgoliaCategories = () => {
  const locale = useAlgoliaLocale();
  return [
    `category${locale}.lvl0`,
    `category${locale}.lvl1`,
    `category${locale}.lvl2`,
  ];
};
